<template>
  <div class="breadcrumb">
    <h2>
      <span class="crumb">
        <router-link :to="{ name: 'trips' }">Dashboard</router-link>
        <span class="icon">&gt;</span>
      </span>
      <span v-if="subtitle" class="crumb">
        <router-link :to="parentRoute">{{ title }}</router-link>
        <span class="icon">&gt;</span>
      </span>
      <span>{{ subtitle || title }}</span>
    </h2>
  </div>
</template>

<script setup>
import { computed } from "vue";
import { useRoute } from "vue-router";
const route = useRoute();

// Get computed value for title
const title = computed(() => {
  if (route.name.includes("trips")) {
    return "Trips";
  } else if (route.name.includes("groups")) {
    return "Groups";
  } else if (route.name.includes("report")) {
    return "Reports";
  } else if (route.name.includes("setting")) {
    return "Settings";
  } else {
    return "Page";
  }
});

// Get subtitle from route name (third level)
const subtitle = computed(() => {
  // Special handling for custom reports
  if (route.name.includes("reports_custom")) {
    return "Custom Report";
  }

  const routeParts = route.name.split("_");
  if (routeParts.length >= 2 && (route.name.includes("settings_") || route.name.includes("reports_"))) {
    // Convert snake_case to Title Case
    return routeParts
      .slice(1)
      .join(" ")
      .replace(/\b\w/g, l => l.toUpperCase());
  }
  return null;
});

// Get parent route for middle breadcrumb link
const parentRoute = computed(() => {
  if (route.name.includes("settings")) return { name: "settings_account" };
  if (route.name.includes("reports")) return { name: "reports_flights_manifest" };
  return { name: "trips" };
});
</script>
